import { EcommerceHead } from './EcommerceHead'

import { usePlanListDataLayerObject } from '../../../hooks'

/**
 * Ecommerce head for the facility-wide plan index (`/:property/plans`).
 *
 * Uses the property-level `usePlanListDataLayerObject` (room-independent), not
 * the room-scoped `usePlanDataLayerObject` which would emit `null` on this
 * route (no `room` param).
 */
export const PlanListIndexHead = () => {
  const dataLayerObject = usePlanListDataLayerObject()

  return dataLayerObject && <EcommerceHead dataLayerObject={dataLayerObject} />
}
